// Third Party Helpers
import { format, addMinutes } from 'date-fns'

function formatCurrency (value) {
  if (!value && value !== 0) return null 
  return ((value * 100) / 100).toFixed(2) 
}

function formatDate (date) {
  // trying to prevent 'RangeError: Invalid time value'
  if (!date) return
  date = new Date(date)
  // add minutes to offset timezone difference from UTC
  date = addMinutes(date, date.getTimezoneOffset())
  return format(date, CONSTANTS.date_format)
}

function formatTimestamp (date) {
  if (!date) return
  date = new Date(date)
  return format(date, CONSTANTS.timestamp)
}

function objectStringsToFloat (updateObject) {
  Object.keys(updateObject).forEach(key => {
    if (!['id', 'name', 'dt', 'promo_number', 'date'].some(v => key.includes(v))) {
      if (!isNaN(parseFloat(updateObject[key]))) {
         // If we want to keep 2 places after the decimal then numbers round automatically
        updateObject[key] = parseFloat(updateObject[key]).toFixed(2)
        updateObject[key] = parseFloat(updateObject[key])
      }
    }
  })
}

function removeSpecialCharacter (specialCharString) {
  const reg_pattern = /[~`!#$%^&*+=\-[\]\\';,/{}|\\":<>?]/g
  return specialCharString.replace(reg_pattern, '')
}

function nullifyEmptyStrings (obj) {
  for (const key of Object.keys(obj)) {
    if (obj[key] === "") obj[key] = null
  }
  return obj
}

const CONSTANTS = {
  timestamp: 'M/d/yyyy - h:mm:ss a',
  date_format: 'M/d/yyyy',
  formatCurrency: formatCurrency,
  formatDate: formatDate,
  formatTimestamp: formatTimestamp,
  objectStringsToFloat: objectStringsToFloat,
  removeSpecialChar: removeSpecialCharacter,
  nullifyEmptyStrings
}

const WHOLESALER_ITEM_SOURCE = {
  'Associated Wholesale Grocers': 'awg_unique',
  'C&S Wholesale Grocers': 'csw',
  'JB Gottstein': 'jbg',
  'Piggly Wiggly Alabama Distributing Co., Inc.': 'pwa',
  'SpartanNash Company': 'spn'
}


export default { CONSTANTS, WHOLESALER_ITEM_SOURCE }
